import {
  defaultFormImages,
  embedColorCode,
} from "components/Reusable/JUMBOform/ExternalJsonsList/JsonLists.js";
import getAsyncImage from "utils/getAsyncImage";
import config from "config";

export const updatePageDetails = async ({
  FullDetailsEmbedPage,
  setTextPage,
  setTitlePage,
  setPersonalPageUrl,
  setDiractionPage,
  directionUrl,
  setSingleOrRotate,
  setSelectedForms,
  setEmbedPageFormList,
  setBackgroundImagesList,
  setLogoImage,
  socialLinks,
  setBodyScripts,
  setHeadScripts,
  setMetaDescription,
  setBrowserTitle,
  setShowOrderTracker,
  setBrandingColor,
  setFormImages,
  setSingleForm,
  setOldEmbedPageFormList,
  setLinkFooters,
  setUserFormsList,
  setPageLanguage,
  setSearchEngines,
  demoPageId,
  tempImage,
  setTempImage,
  setDisplayFormDetialsDB,
  setDisplaySidePanel,
}) => {
  if (FullDetailsEmbedPage) {
    if (FullDetailsEmbedPage.EmbedDynamicPage) {
      setTextPage(
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageBoxText
          ? FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageBoxText
          : ""
      );
      setTitlePage(
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageBoxTitle
          ? FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageBoxTitle
          : ""
      );
      if (!demoPageId) {
        setPersonalPageUrl(
          FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageUserName &&
            FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageUserName
        );
      }

      if (!demoPageId) {
        setDiractionPage(
          FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageDirection
            ? FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageDirection
            : directionUrl
        );
      } else {
        setDiractionPage(directionUrl);
      }

      setSingleOrRotate(
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageBackgroundDisplay &&
          FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageBackgroundDisplay
      );
      setShowOrderTracker(
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageShowOrderTracker
      );
      setBrandingColor(
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedDynamicPageBrandingColor
          ? FullDetailsEmbedPage.EmbedDynamicPage.EmbedDynamicPageBrandingColor
          : embedColorCode
      );
      if (FullDetailsEmbedPage.EmbedDynamicPage.FooterLinks) {
        setLinkFooters(FullDetailsEmbedPage.EmbedDynamicPage.FooterLinks);
      }
      if (!demoPageId) {
        if (FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageCulture) {
          setPageLanguage(
            FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageCulture
          );
        }
      }
      setDisplayFormDetialsDB(
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedDynamicPageDisplayFormDetails
      );
      setDisplaySidePanel(
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedDynamicPageDisplaySidePanel
      );
      if (
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageSearchEngines !== null &&
        !demoPageId
      ) {
        setSearchEngines(
          FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageSearchEngines
        );
      }
    }
    let tempList = [];

    if (FullDetailsEmbedPage.EmbedDynamicForms) {
      for (let i = 0; i < FullDetailsEmbedPage.EmbedDynamicForms.length; i++) {
        const element = FullDetailsEmbedPage.EmbedDynamicForms[i];
        const callBackImage = (imgUrl) => {
          let tempElement = element;
          tempElement.Embed_Dynamic_Image_Url = imgUrl;
          tempList.push(tempElement);
        };
        if (
          element.Embed_Dynamic_Image &&
          element.Embed_Dynamic_Image.EmbedDynamicFormImageLogicalPath
        ) {
          tempList.push(element);
        } else {
          if (element.Embed_Dynamic_Image_Url) {
            if (
              !element.Embed_Dynamic_Image_Url.includes("/") &&
              !element.Embed_Dynamic_Image_Url.includes(
                `${config.api.resource}/assets/images/picker/picker-app.png`
              )
            ) {
              await getAsyncImage(
                `images/personal/form-images/webp/${element.Embed_Dynamic_Image_Url}.webp`,
                callBackImage
              );
            } else if (
              element.Embed_Dynamic_Image_Url.includes(
                `${config.api.resource}/assets/images/picker/picker-app.png`
              )
            ) {
              callBackImage(element.Embed_Dynamic_Image_Url);
            }
          } else {
            await getAsyncImage(
              `images/${defaultFormImages[i]}.webp`,
              callBackImage
            );
          }
        }
      }
      FullDetailsEmbedPage.EmbedDynamicForms = tempList;
      setUserFormsList(tempList);
    }
    if (
      FullDetailsEmbedPage.EmbedDynamicPageFormList &&
      FullDetailsEmbedPage.EmbedDynamicPageFormList.length > 0
    ) {
      let count = 0;
      let tempForm = null;
      let tempListForm = [];
      let tempImagesList = [];
      FullDetailsEmbedPage.EmbedDynamicPageFormList.forEach((element) => {
        if (!element.EmbedPageFormImage) {
          tempForm = { ...element };
          const imageForm = tempList.filter(
            (item) => item.Embed_Dynamic_Id == element.EmbedPageFormId
          )[0];
          tempForm.EmbedPageFormImage = imageForm?.Embed_Dynamic_Image_Url
            ? imageForm.Embed_Dynamic_Image_Url
            : null;
          tempListForm.push(tempForm);
          count++;
        } else {
          tempImagesList.push(element.EmbedPageFormImage);
          tempListForm.push(element);
        }
      });

      setFormImages(tempImagesList);
      setEmbedPageFormList(tempListForm);
      setOldEmbedPageFormList(tempListForm);
      setSelectedForms(
        FullDetailsEmbedPage.EmbedDynamicPageFormList.map(
          (item) => item.EmbedPageFormId
        )
      );
      if (FullDetailsEmbedPage.EmbedDynamicPageFormList.length === 1) {
        setSingleForm(true);
      }
    }

    setBackgroundImagesList(
      FullDetailsEmbedPage.EmbedDynamicPageImageList
        ? FullDetailsEmbedPage.EmbedDynamicPageImageList
        : []
    );
    if (FullDetailsEmbedPage.EmbedDynamicPageLogo) {
      setLogoImage(
        FullDetailsEmbedPage.EmbedDynamicPageLogo &&
          FullDetailsEmbedPage.EmbedDynamicPageLogo
      );
    }
    if (
      FullDetailsEmbedPage &&
      FullDetailsEmbedPage.EmbedDynamicPageLinkList &&
      FullDetailsEmbedPage.EmbedDynamicPageLinkList.length > 0
    ) {
      FullDetailsEmbedPage.EmbedDynamicPageLinkList.forEach((element) => {
        socialLinks.forEach((link) => {
          if (
            element.EmbedPageLinkSourceName.toLowerCase() ===
            link.name.toLowerCase()
          ) {
            link.setState(element.EmbedPageLinkUrl);
          }
        });
      });
    }
    if (
      FullDetailsEmbedPage &&
      FullDetailsEmbedPage.EmbedDynamicPageScripts &&
      !demoPageId
    ) {
      setBodyScripts(
        FullDetailsEmbedPage.EmbedDynamicPageScripts.EmbedPageScriptBody
          ? FullDetailsEmbedPage.EmbedDynamicPageScripts.EmbedPageScriptBody
          : ""
      );
      setHeadScripts(
        FullDetailsEmbedPage.EmbedDynamicPageScripts.EmbedPageScriptHead
          ? FullDetailsEmbedPage.EmbedDynamicPageScripts.EmbedPageScriptHead
          : ""
      );
    }
    if (!demoPageId) {
      setMetaDescription(
        FullDetailsEmbedPage.EmbedDynamicPageScripts &&
          FullDetailsEmbedPage.EmbedDynamicPageScripts
            .EmbedDynamicPageScriptMetaDescription
          ? FullDetailsEmbedPage.EmbedDynamicPageScripts
              .EmbedDynamicPageScriptMetaDescription
          : ""
      );

      setBrowserTitle(
        FullDetailsEmbedPage.EmbedDynamicPageScripts &&
          FullDetailsEmbedPage.EmbedDynamicPageScripts
            .EmbedDynamicPageScriptBrowserTitle
          ? FullDetailsEmbedPage.EmbedDynamicPageScripts
              .EmbedDynamicPageScriptBrowserTitle
          : ""
      );
    }
  }
};
